import type { AButtonType, MultiLinkType } from '../types/storyblok';

export const sanitizeStoryblokLink = (href: string) => {
  if (href.includes(':') || href.startsWith('/') || href.startsWith('#')) {
    return href;
  }

  return `/${href}`;
};

export const buildUrl = (
  entry: Exclude<MultiLinkType, { linktype?: 'email' }>,
  linkUrl?: string,
): string | undefined => {
  return entry.cached_url ? `${sanitizeStoryblokLink(entry.cached_url)}` : linkUrl;
};

export const getHref = ({ linkAsset, linkEntry, linkUrl }: Partial<AButtonType>): string => {
  if (linkEntry?.cached_url) {
    const sanitizedUrl = sanitizeStoryblokLink(linkEntry.cached_url);
    return linkEntry.linktype === 'story' ? `${sanitizedUrl}${linkUrl ? linkUrl : ''}` : sanitizedUrl;
  }

  return linkAsset?.filename ?? '';
};
